import React from 'react'

import PropTypes from 'prop-types'

import './woordkunst-component.css'

const WoordkunstComponent = (props) => {
  return (
    <div className="woordkunst-component-container1">
      <div className="woordkunst-component-container2">
        <div className="woordkunst-component-container3">
          <h1 className="woordkunst-component-text1">{props.title}</h1>
          <span className="woordkunst-component-text2">{props.text}</span>
        </div>
        <img
          alt={props.imageAlt}
          src={props.imageSrc}
          className="woordkunst-component-image"
        />
      </div>
    </div>
  )
}

WoordkunstComponent.defaultProps = {
  imageAlt: 'image',
  text: 'Gedicht of haiku',
  imageSrc: 'https://play.teleporthq.io/static/svg/default-img.svg',
  title: 'Titel',
}

WoordkunstComponent.propTypes = {
  imageAlt: PropTypes.string,
  text: PropTypes.string,
  imageSrc: PropTypes.string,
  title: PropTypes.string,
}

export default WoordkunstComponent
